import { createStoreon } from "storeon";
import { storeonLogger, storeonDevtools } from "storeon/devtools";

import cachePool from "./cachePool";
import uploadPool from "./uploadPool";
import notifications from "./notifications";
import menu from "./menu";
import activeObject from "./activeObject";
import canvas from "./canvas";
import editors from "./editors";
import cart from "./cart";
import id from "./id";
import preview from "./preview";
import collage from "./collage";
import products from "./products";
import price from "./price";
import config from "./config";

const isAdmin = (store) => {
  store.on("@init", (_) => ({ isAdmin: window.isDeskpadAdmin }));
};

const editorType = (store) => {
  store.on("@init", (_) => ({ editorType: "printfile" }));
  store.on("setEditorType/printfile", (_) => {
    return { editorType: "printfile" };
  });

  store.on("setEditorType/printplate", (_) => {
    return { editorType: "printplate" };
  });

  store.on("setEditorType/collage", (_) => {
    return { editorType: "collage" };
  });
};

const printplates = (store) => {
  store.on("@init", () => ({ printplates: [] }));
  store.on("printplates/set", (_, printplates) => {
    return { printplates };
  });
};

const orders = (store) => {
  store.on("@init", () => ({ orders: [] }));
  store.on("orders/set", (_, orders) => {
    return { orders };
  });
};

const productselector = (store) => {
  store.on("@init", (_) => ({ isProductSelectorOpened: false }));
  store.on("productSelector/open", (_) => {
    return { isProductSelectorOpened: true };
  });
  store.on("productSelector/close", (_) => {
    return { isProductSelectorOpened: false };
  });
};

const settings = (store) => {
  store.on("@init", () => ({ snapValue: false }));
  store.on("settings/snapvalue", (_, val) => {
    return { snapValue: val };
  });
};

export default createStoreon([
  cachePool,
  notifications,
  menu,
  uploadPool,
  activeObject,
  canvas,
  isAdmin,
  editorType,
  id,
  editors,
  printplates,
  orders,
  cart,
  preview,
  collage,
  products,
  productselector,
  price,
  config,
  settings,
  process.env.NODE_ENV !== "production" && storeonLogger,
  process.env.NODE_ENV !== "production" && storeonDevtools,
]);
